
const disableCheckoutButtons = (checkoutButtons) => {
  for (let j=0; j<checkoutButtons.length; j++) {
    checkoutButtons[j].classList.add('disabled-checkout');
  }
}

const enableCheckoutButtons = (checkoutButtons) => {
   for (let k=0; k<checkoutButtons.length; k++) {
      checkoutButtons[k].classList.remove('disabled-checkout');
    }
}

const handleCheckoutButtons = () => {
  var checkoutButtons = document.getElementsByName('checkout');
  var tacc = document.getElementsByName('terms-and-conditions-checkbox');
  
  // Apply disabled styles to checkout buttons. 
  disableCheckoutButtons(checkoutButtons);

  for (let l=0; l<tacc.length; l++){
    tacc[l].addEventListener('click', ()=> {
      let checked = tacc[l].checked;
      
      if (checked) {
         enableCheckoutButtons(checkoutButtons);
      } else if (!checked) {
        disableCheckoutButtons(checkoutButtons);
      }
    })
  }
  
}


      
window.onload = () => {
  
}




var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}
